import React, { createContext, useContext, useEffect, useState } from "react";
import { translations, LANGS } from "@/i18n/translations";

const LanguageContext = createContext({
  lang: "fr",
  setLang: () => {},
  t: translations.fr,
});

const STORAGE_KEY = "klairys.lang";

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState("fr");

  useEffect(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved && LANGS.includes(saved)) {
        setLangState(saved);
        return;
      }
      const browser = (navigator.language || "fr").slice(0, 2);
      if (LANGS.includes(browser)) setLangState(browser);
    } catch (e) {
      // ignore storage errors
    }
  }, []);

  const setLang = (next) => {
    setLangState(next);
    try {
      localStorage.setItem(STORAGE_KEY, next);
    } catch (e) {
      // ignore
    }
    document.documentElement.lang = next;
  };

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const value = {
    lang,
    setLang,
    t: translations[lang] || translations.fr,
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useT() {
  return useContext(LanguageContext);
}
